import { render, staticRenderFns } from "./dashboard-tab.vue?vue&type=template&id=6edbb52b&scoped=true"
import script from "./dashboard-tab.vue?vue&type=script&lang=js"
export * from "./dashboard-tab.vue?vue&type=script&lang=js"
import style0 from "./dashboard-tab.vue?vue&type=style&index=0&id=6edbb52b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edbb52b",
  null
  
)

export default component.exports